import React from 'react'
import CompliancesDesktop from './CompliancesDesktop';
import CompliancesMobile from './CompliancesMobile';

const Compliances = () => {
  return (
    <div>
      <div className={`hidden lg:flex flex-col`}>
        <CompliancesDesktop />
      </div>
      <div className={`flex lg:hidden`}>
        <CompliancesMobile />
      </div>
    </div>
  );
};

export default Compliances;